import Svg, {
  ClipPath,
  Defs,
  FeBlend,
  FeColorMatrix,
  FeComposite,
  FeFlood,
  FeGaussianBlur,
  FeMorphology,
  FeOffset,
  Filter,
  G,
  Path,
  Rect,
  TSpan,
  Text,
} from 'react-native-svg';

export const GrossSalaryActivityAsset = ({
  width = 301,
  height = 331,
  cardTitle,
  cardValue,
  activityTitle,
  className,
}: TGrossSalaryActivityAssetProps) => {
  return (
    <Svg
      className={className}
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 302 331"
    >
      <G clipPath="url(#gross-salary-activity-asset-a)">
        <Path
          fill="#FCF5F2"
          stroke="#FDBD9A"
          strokeWidth="3.865"
          d="M1.933 29.292c0-15.11 12.249-27.36 27.359-27.36h210.903c15.11 0 27.359 12.25 27.359 27.36v304.169H1.933V29.292Z"
        />
        <G clipPath="url(#gross-salary-activity-asset-b)">
          <Text
            fill="#5F7287"
            fontFamily="F37 Ginger Pro"
            fontSize="11.717"
            fontWeight="bold"
            letterSpacing="0"
          >
            <TSpan x="214.78" y="251.443">
              -€€
            </TSpan>
          </Text>
          <Text
            fill="#00A276"
            fontFamily="F37 Ginger Pro"
            fontSize="11.717"
            fontWeight="bold"
            letterSpacing="0"
          >
            <TSpan x="203.714" y="300.628">
              +€€€
            </TSpan>
          </Text>
          <Path
            fill="#8E9CAB"
            d="M56.63 247.318c0-.279.065-.526.195-.741a1.31 1.31 0 0 1 .516-.516 1.4 1.4 0 0 1 .74-.195h5.498c.28 0 .527.065.74.195.222.123.394.295.517.516.13.215.195.462.195.741v.02c0 .279-.065.529-.195.75a1.41 1.41 0 0 1-.516.517 1.462 1.462 0 0 1-.74.185h-5.498c-.28 0-.526-.062-.74-.185a1.41 1.41 0 0 1-.517-.517 1.451 1.451 0 0 1-.195-.75v-.02Z"
          />
          <Path
            fill="#FF8E7A"
            d="M45.725 241.337a5.474 5.474 0 0 1-4.773 5.434 6.202 6.202 0 0 0-1.59-3.402 5.516 5.516 0 0 1 4.797-2.815h.783c.416 0 .783.367.783.783Zm-12.532 1.567a.79.79 0 0 1 .784-.784h.783c3.01 0 5.483 2.473 5.483 5.483v4.7c0 .44-.368.783-.784.783a.773.773 0 0 1-.783-.783v-3.917a5.473 5.473 0 0 1-5.483-5.482Z"
          />
          <Path
            fill="#8E9CAB"
            d="M62.103 247.318c0-.279.065-.526.195-.741.123-.221.295-.393.516-.516a1.4 1.4 0 0 1 .741-.195h5.497c.28 0 .527.065.741.195.221.123.393.295.517.516.13.215.195.462.195.741v.02c0 .279-.065.529-.195.75a1.411 1.411 0 0 1-.517.517 1.463 1.463 0 0 1-.74.185h-5.498c-.28 0-.526-.062-.74-.185a1.411 1.411 0 0 1-.517-.517 1.451 1.451 0 0 1-.195-.75v-.02Z"
          />
          <Path
            fill="#00A276"
            d="M41.026 291.625h-3.133l-1.175-1.738c-.171-.245.024-.612.318-.612h4.822c.294 0 .49.367.318.612l-1.15 1.738Zm-3.133.783h3.133c.073.073.196.147.318.22 1.37.881 4.381 2.79 4.381 6.829a2.35 2.35 0 0 1-2.35 2.35h-7.832a2.35 2.35 0 0 1-2.35-2.35c0-4.039 2.986-5.948 4.382-6.829.097-.073.22-.147.318-.22Zm2.056 2.154c0-.269-.22-.49-.49-.49-.269 0-.49.221-.49.49v.342a2.245 2.245 0 0 0-.562.221c-.343.196-.637.563-.612 1.077 0 .489.294.807.587 1.003.27.147.612.245.882.343h.048c.294.098.514.171.686.269.122.074.122.122.122.196.025.122-.024.196-.122.245-.123.098-.318.122-.539.122-.269 0-.514-.098-.856-.196-.05-.024-.123-.049-.172-.073-.269-.074-.538.049-.612.318a.473.473 0 0 0 .294.612c.05.024.098.024.147.049.22.073.44.147.685.22v.343a.49.49 0 0 0 .98 0v-.318c.195-.049.39-.123.587-.221.342-.22.612-.587.587-1.101 0-.514-.27-.832-.587-1.028a3.907 3.907 0 0 0-.906-.367h-.024c-.319-.098-.539-.172-.686-.269-.122-.074-.147-.123-.147-.147 0-.098.05-.172.172-.245.122-.074.318-.122.514-.122.245 0 .49.073.759.146a.525.525 0 0 0 .611-.367c.074-.244-.097-.514-.342-.587a3.993 3.993 0 0 0-.514-.123v-.342Z"
          />
          <Path
            fill="#8E9CAB"
            d="M67.576 247.318c0-.279.065-.526.195-.741.123-.221.296-.393.516-.516a1.4 1.4 0 0 1 .741-.195h5.497c.28 0 .527.065.741.195.221.123.393.295.517.516.13.215.195.462.195.741v.02c0 .279-.065.529-.195.75a1.412 1.412 0 0 1-.517.517 1.463 1.463 0 0 1-.74.185h-5.498c-.28 0-.526-.062-.74-.185a1.412 1.412 0 0 1-.517-.517 1.451 1.451 0 0 1-.195-.75v-.02Z"
          />
          <Path
            fill="#8E9CAB"
            d="M73.049 247.318c0-.279.065-.526.195-.741.123-.221.296-.393.516-.516a1.4 1.4 0 0 1 .741-.195H80c.279 0 .526.065.74.195.221.123.393.295.517.516.13.215.195.462.195.741v.02c0 .279-.065.529-.195.75a1.412 1.412 0 0 1-.517.517 1.462 1.462 0 0 1-.74.185H74.5c-.28 0-.526-.062-.74-.185a1.412 1.412 0 0 1-.517-.517 1.452 1.452 0 0 1-.195-.75v-.02Z"
          />
          <Path
            fill="#8E9CAB"
            d="M78.522 247.318c0-.279.065-.526.195-.741.124-.221.296-.393.517-.516a1.4 1.4 0 0 1 .74-.195h2.807c.28 0 .527.065.741.195.221.123.393.295.517.516.13.215.195.462.195.741v.02c0 .279-.065.529-.195.75a1.411 1.411 0 0 1-.517.517 1.463 1.463 0 0 1-.74.185h-2.808c-.279 0-.526-.062-.74-.185a1.412 1.412 0 0 1-.517-.517 1.452 1.452 0 0 1-.195-.75v-.02Z"
          />
          <Path
            fill="#8E9CAB"
            d="M81.311 247.318c0-.279.065-.526.195-.741.123-.221.296-.393.516-.516a1.4 1.4 0 0 1 .741-.195h5.497c.28 0 .527.065.741.195.221.123.393.295.517.516.13.215.195.462.195.741v.02c0 .279-.065.529-.195.75a1.412 1.412 0 0 1-.517.517 1.462 1.462 0 0 1-.74.185h-5.498c-.28 0-.526-.062-.74-.185a1.412 1.412 0 0 1-.517-.517 1.452 1.452 0 0 1-.195-.75v-.02Z"
          />
          <Path
            fill="#8E9CAB"
            d="M86.784 247.318c0-.279.065-.526.195-.741.124-.221.296-.393.517-.516a1.4 1.4 0 0 1 .74-.195h2.807c.28 0 .527.065.741.195.221.123.393.295.517.516.13.215.195.462.195.741v.02c0 .279-.065.529-.195.75a1.412 1.412 0 0 1-.517.517 1.463 1.463 0 0 1-.74.185h-2.808c-.279 0-.526-.062-.74-.185a1.411 1.411 0 0 1-.517-.517 1.451 1.451 0 0 1-.195-.75v-.02Z"
          />
          <Path
            fill="#8E9CAB"
            d="M89.573 247.318c0-.279.065-.526.195-.741a1.31 1.31 0 0 1 .517-.516 1.4 1.4 0 0 1 .74-.195h2.807c.28 0 .527.065.741.195.221.123.393.295.517.516.13.215.195.462.195.741v.02c0 .279-.065.529-.195.75a1.412 1.412 0 0 1-.517.517 1.462 1.462 0 0 1-.74.185h-2.808c-.28 0-.526-.062-.74-.185a1.41 1.41 0 0 1-.517-.517 1.451 1.451 0 0 1-.195-.75v-.02Z"
          />
          <Path
            fill="#8E9CAB"
            d="M92.362 247.318c0-.279.065-.526.195-.741a1.31 1.31 0 0 1 .516-.516 1.4 1.4 0 0 1 .741-.195h5.498c.279 0 .526.065.74.195.221.123.393.295.517.516.13.215.195.462.195.741v.02c0 .279-.065.529-.195.75a1.416 1.416 0 0 1-.517.517 1.46 1.46 0 0 1-.74.185h-5.498c-.28 0-.526-.062-.74-.185a1.41 1.41 0 0 1-.517-.517 1.451 1.451 0 0 1-.195-.75v-.02ZM103.679 247.318c0-.279.065-.526.195-.741.124-.221.296-.393.517-.516.214-.13.461-.195.741-.195h5.497c.279 0 .526.065.741.195.221.123.393.295.516.516.13.215.195.462.195.741v.02c0 .279-.065.529-.195.75a1.406 1.406 0 0 1-.516.517 1.466 1.466 0 0 1-.741.185h-5.497a1.46 1.46 0 0 1-.741-.185 1.416 1.416 0 0 1-.517-.517 1.451 1.451 0 0 1-.195-.75v-.02Z"
          />
          <Path
            fill="#8E9CAB"
            d="M109.153 247.318c0-.279.064-.526.194-.741.124-.221.296-.393.517-.516.214-.13.461-.195.741-.195h5.497c.279 0 .526.065.741.195.221.123.393.295.516.516.13.215.195.462.195.741v.02c0 .279-.065.529-.195.75a1.406 1.406 0 0 1-.516.517 1.466 1.466 0 0 1-.741.185h-5.497a1.46 1.46 0 0 1-.741-.185 1.416 1.416 0 0 1-.517-.517 1.45 1.45 0 0 1-.194-.75v-.02Z"
          />
          <Path
            fill="#8E9CAB"
            d="M114.626 247.318c0-.279.065-.526.195-.741.123-.221.295-.393.516-.516.215-.13.461-.195.741-.195h5.497c.28 0 .526.065.741.195.221.123.393.295.517.516.129.215.194.462.194.741v.02c0 .279-.065.529-.194.75a1.416 1.416 0 0 1-.517.517 1.463 1.463 0 0 1-.741.185h-5.497c-.28 0-.526-.062-.741-.185a1.406 1.406 0 0 1-.516-.517 1.451 1.451 0 0 1-.195-.75v-.02Z"
          />
          <Path
            fill="#8E9CAB"
            d="M120.099 247.318c0-.279.065-.526.195-.741.123-.221.295-.393.516-.516.215-.13.462-.195.741-.195h2.807c.28 0 .526.065.741.195.221.123.393.295.516.516.13.215.195.462.195.741v.02c0 .279-.065.529-.195.75a1.406 1.406 0 0 1-.516.517 1.463 1.463 0 0 1-.741.185h-2.807c-.279 0-.526-.062-.741-.185a1.406 1.406 0 0 1-.516-.517 1.451 1.451 0 0 1-.195-.75v-.02Z"
          />
          <Path
            fill="#8E9CAB"
            d="M122.888 247.318c0-.279.065-.526.195-.741.123-.221.295-.393.516-.516.215-.13.462-.195.741-.195h2.807c.279 0 .526.065.741.195.221.123.393.295.516.516.13.215.195.462.195.741v.02c0 .279-.065.529-.195.75a1.406 1.406 0 0 1-.516.517 1.466 1.466 0 0 1-.741.185h-2.807c-.279 0-.526-.062-.741-.185a1.406 1.406 0 0 1-.516-.517 1.451 1.451 0 0 1-.195-.75v-.02Z"
          />
          <Path
            fill="#8E9CAB"
            d="M125.677 247.318c0-.279.065-.526.194-.741.124-.221.296-.393.517-.516.215-.13.461-.195.741-.195h5.497c.28 0 .526.065.741.195.221.123.393.295.516.516.13.215.195.462.195.741v.02c0 .279-.065.529-.195.75a1.406 1.406 0 0 1-.516.517 1.463 1.463 0 0 1-.741.185h-5.497c-.28 0-.526-.062-.741-.185a1.416 1.416 0 0 1-.517-.517 1.46 1.46 0 0 1-.194-.75v-.02Z"
          />
          <Path
            fill="#8E9CAB"
            d="M131.15 247.318c0-.279.065-.526.195-.741.123-.221.295-.393.516-.516.215-.13.462-.195.741-.195h2.807c.279 0 .526.065.741.195.221.123.393.295.516.516.13.215.195.462.195.741v.02c0 .279-.065.529-.195.75a1.406 1.406 0 0 1-.516.517 1.466 1.466 0 0 1-.741.185h-2.807c-.279 0-.526-.062-.741-.185a1.406 1.406 0 0 1-.516-.517 1.451 1.451 0 0 1-.195-.75v-.02Z"
          />
          <Path
            fill="#8E9CAB"
            d="M133.939 247.318c0-.279.065-.526.195-.741.123-.221.295-.393.516-.516.215-.13.461-.195.741-.195h5.497c.28 0 .526.065.741.195.221.123.393.295.516.516.13.215.195.462.195.741v.02c0 .279-.065.529-.195.75a1.406 1.406 0 0 1-.516.517 1.463 1.463 0 0 1-.741.185h-5.497c-.28 0-.526-.062-.741-.185a1.406 1.406 0 0 1-.516-.517 1.451 1.451 0 0 1-.195-.75v-.02ZM56.63 295.65c0-.28.065-.527.195-.741a1.32 1.32 0 0 1 .516-.517 1.4 1.4 0 0 1 .74-.194h5.498c.28 0 .527.064.74.194.222.124.394.296.517.517.13.214.195.461.195.741v.019c0 .28-.065.53-.195.751a1.408 1.408 0 0 1-.516.516 1.453 1.453 0 0 1-.74.186h-5.498c-.28 0-.526-.062-.74-.186a1.408 1.408 0 0 1-.517-.516 1.452 1.452 0 0 1-.195-.751v-.019Z"
          />
          <Path
            fill="#8E9CAB"
            d="M62.103 295.65c0-.28.065-.527.195-.741a1.32 1.32 0 0 1 .516-.517 1.4 1.4 0 0 1 .741-.194h5.497c.28 0 .527.064.741.194.221.124.393.296.517.517.13.214.195.461.195.741v.019c0 .28-.065.53-.195.751a1.408 1.408 0 0 1-.517.516 1.453 1.453 0 0 1-.74.186h-5.498c-.28 0-.526-.062-.74-.186a1.409 1.409 0 0 1-.517-.516 1.452 1.452 0 0 1-.195-.751v-.019Z"
          />
          <Path
            fill="#8E9CAB"
            d="M67.576 295.65c0-.28.065-.527.195-.741.123-.221.296-.393.516-.517a1.4 1.4 0 0 1 .741-.194h5.497c.28 0 .527.064.741.194.221.124.393.296.517.517a1.4 1.4 0 0 1 .195.741v.019c0 .28-.065.53-.195.751a1.41 1.41 0 0 1-.517.516 1.453 1.453 0 0 1-.74.186h-5.498c-.28 0-.526-.062-.74-.186a1.41 1.41 0 0 1-.517-.516 1.452 1.452 0 0 1-.195-.751v-.019Z"
          />
          <Path
            fill="#8E9CAB"
            d="M73.049 295.65c0-.28.065-.527.195-.741.123-.221.296-.393.516-.517a1.4 1.4 0 0 1 .741-.194H80c.279 0 .526.064.74.194.221.124.393.296.517.517a1.4 1.4 0 0 1 .195.741v.019c0 .28-.065.53-.195.751a1.41 1.41 0 0 1-.517.516 1.453 1.453 0 0 1-.74.186H74.5c-.28 0-.526-.062-.74-.186a1.41 1.41 0 0 1-.517-.516 1.453 1.453 0 0 1-.195-.751v-.019Z"
          />
          <Path
            fill="#8E9CAB"
            d="M78.522 295.65c0-.28.065-.527.195-.741.124-.221.296-.393.517-.517a1.4 1.4 0 0 1 .74-.194h2.807c.28 0 .527.064.741.194.221.124.393.296.517.517.13.214.195.461.195.741v.019c0 .28-.065.53-.195.751a1.408 1.408 0 0 1-.517.516 1.453 1.453 0 0 1-.74.186h-2.808c-.279 0-.526-.062-.74-.186a1.41 1.41 0 0 1-.517-.516 1.453 1.453 0 0 1-.195-.751v-.019Z"
          />
          <Path
            fill="#8E9CAB"
            d="M81.311 295.65c0-.28.065-.527.195-.741.123-.221.296-.393.516-.517a1.4 1.4 0 0 1 .741-.194h5.497c.28 0 .527.064.741.194.221.124.393.296.517.517.13.214.195.461.195.741v.019c0 .28-.065.53-.195.751a1.41 1.41 0 0 1-.517.516 1.453 1.453 0 0 1-.74.186h-5.498c-.28 0-.526-.062-.74-.186a1.41 1.41 0 0 1-.517-.516 1.453 1.453 0 0 1-.195-.751v-.019Z"
          />
          <Path
            fill="#8E9CAB"
            d="M86.784 295.65c0-.28.065-.527.195-.741a1.32 1.32 0 0 1 .517-.517 1.4 1.4 0 0 1 .74-.194h2.807c.28 0 .527.064.741.194.221.124.393.296.517.517a1.4 1.4 0 0 1 .195.741v.019c0 .28-.065.53-.195.751a1.41 1.41 0 0 1-.517.516 1.453 1.453 0 0 1-.74.186h-2.808c-.279 0-.526-.062-.74-.186a1.408 1.408 0 0 1-.517-.516 1.452 1.452 0 0 1-.195-.751v-.019Z"
          />
          <Path
            fill="#8E9CAB"
            d="M89.573 295.65c0-.28.065-.527.195-.741a1.32 1.32 0 0 1 .517-.517 1.4 1.4 0 0 1 .74-.194h2.807c.28 0 .527.064.741.194.221.124.393.296.517.517a1.4 1.4 0 0 1 .195.741v.019c0 .28-.065.53-.195.751a1.41 1.41 0 0 1-.517.516 1.453 1.453 0 0 1-.74.186h-2.808c-.28 0-.526-.062-.74-.186a1.408 1.408 0 0 1-.517-.516 1.452 1.452 0 0 1-.195-.751v-.019Z"
          />
          <Path
            fill="#8E9CAB"
            d="M92.362 295.65c0-.28.065-.527.195-.741a1.32 1.32 0 0 1 .516-.517 1.4 1.4 0 0 1 .741-.194h5.498c.279 0 .526.064.74.194.221.124.393.296.517.517.13.214.195.461.195.741v.019c0 .28-.065.53-.195.751a1.414 1.414 0 0 1-.517.516 1.451 1.451 0 0 1-.74.186h-5.498c-.28 0-.526-.062-.74-.186a1.408 1.408 0 0 1-.517-.516 1.452 1.452 0 0 1-.195-.751v-.019ZM103.679 295.65c0-.28.065-.527.195-.741.124-.221.296-.393.517-.517.214-.13.461-.194.741-.194h5.497c.279 0 .526.064.741.194.221.124.393.296.516.517.13.214.195.461.195.741v.019c0 .28-.065.53-.195.751a1.403 1.403 0 0 1-.516.516 1.456 1.456 0 0 1-.741.186h-5.497c-.28 0-.527-.062-.741-.186a1.414 1.414 0 0 1-.517-.516 1.452 1.452 0 0 1-.195-.751v-.019Z"
          />
          <Path
            fill="#8E9CAB"
            d="M109.153 295.65c0-.28.064-.527.194-.741.124-.221.296-.393.517-.517.214-.13.461-.194.741-.194h5.497c.279 0 .526.064.741.194.221.124.393.296.516.517.13.214.195.461.195.741v.019c0 .28-.065.53-.195.751a1.403 1.403 0 0 1-.516.516 1.456 1.456 0 0 1-.741.186h-5.497c-.28 0-.527-.062-.741-.186a1.414 1.414 0 0 1-.517-.516 1.452 1.452 0 0 1-.194-.751v-.019Z"
          />
          <Path
            fill="#8E9CAB"
            d="M114.626 295.65c0-.28.065-.527.195-.741.123-.221.295-.393.516-.517a1.4 1.4 0 0 1 .741-.194h5.497c.28 0 .526.064.741.194.221.124.393.296.517.517.129.214.194.461.194.741v.019c0 .28-.065.53-.194.751a1.414 1.414 0 0 1-.517.516 1.454 1.454 0 0 1-.741.186h-5.497c-.28 0-.526-.062-.741-.186a1.403 1.403 0 0 1-.516-.516 1.452 1.452 0 0 1-.195-.751v-.019Z"
          />
          <Path
            fill="#8E9CAB"
            d="M120.099 295.65c0-.28.065-.527.195-.741.123-.221.295-.393.516-.517.215-.13.462-.194.741-.194h2.807c.28 0 .526.064.741.194.221.124.393.296.516.517.13.214.195.461.195.741v.019c0 .28-.065.53-.195.751a1.403 1.403 0 0 1-.516.516 1.454 1.454 0 0 1-.741.186h-2.807c-.279 0-.526-.062-.741-.186a1.403 1.403 0 0 1-.516-.516 1.452 1.452 0 0 1-.195-.751v-.019Z"
          />
          <Path
            fill="#8E9CAB"
            d="M122.888 295.65c0-.28.065-.527.195-.741.123-.221.295-.393.516-.517.215-.13.462-.194.741-.194h2.807c.279 0 .526.064.741.194.221.124.393.296.516.517.13.214.195.461.195.741v.019c0 .28-.065.53-.195.751a1.403 1.403 0 0 1-.516.516 1.456 1.456 0 0 1-.741.186h-2.807c-.279 0-.526-.062-.741-.186a1.403 1.403 0 0 1-.516-.516 1.452 1.452 0 0 1-.195-.751v-.019Z"
          />
          <Path
            fill="#8E9CAB"
            d="M125.677 295.65c0-.28.065-.527.194-.741.124-.221.296-.393.517-.517a1.4 1.4 0 0 1 .741-.194h5.497c.28 0 .526.064.741.194.221.124.393.296.516.517.13.214.195.461.195.741v.019c0 .28-.065.53-.195.751a1.403 1.403 0 0 1-.516.516 1.454 1.454 0 0 1-.741.186h-5.497c-.28 0-.526-.062-.741-.186a1.414 1.414 0 0 1-.517-.516 1.461 1.461 0 0 1-.194-.751v-.019Z"
          />
          <Path
            fill="#8E9CAB"
            d="M131.15 295.65c0-.28.065-.527.195-.741.123-.221.295-.393.516-.517.215-.13.462-.194.741-.194h2.807c.279 0 .526.064.741.194.221.124.393.296.516.517.13.214.195.461.195.741v.019c0 .28-.065.53-.195.751a1.403 1.403 0 0 1-.516.516 1.456 1.456 0 0 1-.741.186h-2.807c-.279 0-.526-.062-.741-.186a1.403 1.403 0 0 1-.516-.516 1.452 1.452 0 0 1-.195-.751v-.019Z"
          />
          <Path
            fill="#8E9CAB"
            d="M133.939 295.65c0-.28.065-.527.195-.741.123-.221.295-.393.516-.517a1.4 1.4 0 0 1 .741-.194h5.497c.28 0 .526.064.741.194.221.124.393.296.516.517.13.214.195.461.195.741v.019c0 .28-.065.53-.195.751a1.403 1.403 0 0 1-.516.516 1.454 1.454 0 0 1-.741.186h-5.497c-.28 0-.526-.062-.741-.186a1.403 1.403 0 0 1-.516-.516 1.452 1.452 0 0 1-.195-.751v-.019Z"
          />
        </G>
        <G filter="url(#gross-salary-activity-asset-c)">
          <Rect
            width="265.093"
            height="127.42"
            x="20.504"
            y="45.403"
            fill="#F7F8FA"
            rx="15.065"
          />
        </G>
        <G filter="url(#gross-salary-activity-asset-d)">
          <Rect
            width="265.093"
            height="127.42"
            x="36.615"
            y="29.292"
            fill="#F8FBFC"
            rx="15.065"
          />
          <Rect
            width="46.867"
            height="46.867"
            x="237.265"
            y="92.27"
            fill="#FDBD9A"
            fillOpacity=".4"
            rx="17.575"
          />
          <Path
            fill="#333E4A"
            d="M270.951 106.792a8.957 8.957 0 0 1-7.809 8.89 10.14 10.14 0 0 0-2.603-5.566c1.522-2.724 4.485-4.606 7.849-4.606h1.282c.681 0 1.281.601 1.281 1.282Zm-20.504 2.563a1.29 1.29 0 0 1 1.281-1.282h1.282c4.926 0 8.971 4.045 8.971 8.971v7.689a1.29 1.29 0 0 1-1.282 1.281c-.721 0-1.281-.56-1.281-1.281v-6.408a8.956 8.956 0 0 1-8.971-8.97Z"
          />
        </G>
        <Text
          fill="#5F7287"
          fontFamily="F37 Ginger Pro"
          fontSize="11.717"
          fontWeight="bold"
          letterSpacing="0"
        >
          <TSpan x="32.822" y="211.403">
            {activityTitle}
          </TSpan>
        </Text>
        <Text
          fill="#333E4A"
          fontFamily="F37 Ginger Pro"
          fontSize="20.504"
          fontWeight="bold"
          letterSpacing="0"
        >
          <TSpan x="55.655" y="70.312">
            {cardTitle}
          </TSpan>
        </Text>
        <Text
          fill="#333E4A"
          fontFamily="F37 Ginger Pro"
          fontSize="41.009"
          fontWeight="bold"
          letterSpacing="0"
        >
          <TSpan x="55.655" y="129.535">
            {cardValue}
          </TSpan>
        </Text>
      </G>
      <Defs>
        <ClipPath id="gross-salary-activity-asset-a">
          <Path fill="#fff" d="M0 0h301.708v331H0z" />
        </ClipPath>
        <ClipPath id="gross-salary-activity-asset-b">
          <Path
            fill="#fff"
            d="M3.901 29.292c0-13.75 11.148-24.898 24.899-24.898h181.686c13.751 0 24.898 11.147 24.898 24.898V331H3.901V29.292Z"
          />
        </ClipPath>
        <Filter
          id="gross-salary-activity-asset-c"
          width="297.733"
          height="160.06"
          x="4.185"
          y="37.87"
          filterUnits="userSpaceOnUse"
        >
          <FeFlood floodOpacity="0" result="BackgroundImageFix" />
          <FeColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <FeOffset dy="8.788" />
          <FeGaussianBlur stdDeviation="8.16" />
          <FeComposite in2="hardAlpha" operator="out" />
          <FeColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <FeBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1409_24342"
          />
          <FeBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_1409_24342"
            result="shape"
          />
        </Filter>
        <Filter
          id="gross-salary-activity-asset-d"
          width="335.394"
          height="197.721"
          x="1.465"
          y="17.575"
          filterUnits="userSpaceOnUse"
        >
          <FeFlood floodOpacity="0" result="BackgroundImageFix" />
          <FeColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <FeMorphology
            in="SourceAlpha"
            radius="11.717"
            result="effect1_dropShadow_1409_24342"
          />
          <FeOffset dy="23.434" />
          <FeGaussianBlur stdDeviation="23.434" />
          <FeColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <FeBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1409_24342"
          />
          <FeBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_1409_24342"
            result="shape"
          />
        </Filter>
      </Defs>
    </Svg>
  );
};

export type TGrossSalaryActivityAssetProps = {
  width?: number;
  height?: number;
  cardTitle?: string;
  cardValue?: string;
  activityTitle?: string;
  className?: string;
};
